import { StrictMode } from 'react';
import { Router } from './Router';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root')!;

createRoot(container)!.render(
	<StrictMode>
		<Router />
	</StrictMode>
);
